<button type="button" class="btn btn-sm btn-info" (click)="openPrintPreview()" title="Print View">
    <strong><i class="fas fa-print text-primary"></i></strong> 
</button>
